import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';
import * as moment from 'moment';
import { BubleChartColorSelectionService } from '@app/feature/main/roles-shared/services/buble-chart-color-selection.service';
import { bloomAdd } from '@angular/core/src/render3/di';
// import { setInterval } from 'timers'
@Injectable()
export class MarketDataChartGeneratorService {

  chartJSON: any = {};
  marketData: any = {};
  bubbleChartSeriesData;
  bubbleChartMarketData;
  wordChartSeriesData = [];
  maxXValue;
  maxYValue;
  basicColumnData = [];
  maxArray = [];
  maxPercentage: number;

  constructor(private bubleColorService: BubleChartColorSelectionService) {

  }

  generateChartJSON(marketData) {
    let filteredMarketData = [];
    let marketDataChildChoiceMapping = [];
    if (marketData && (marketData.graphType.graphType == "basic_column"
    || marketData.graphType.graphType == 'matrix_stack' 
    || marketData.graphType.graphType === "matrix_multi_line")) {
      if (marketData.matrixChoices != null && marketData.matrixChoices.length > 0 && marketData.marketData !== null) {
        for (let item = 0; item < marketData.marketData.length; item++) {
          for (let key = 0; key < marketData.marketData[item].choices.length; key++) {
            const sel = marketData.matrixChoices[0].choices.find(x => { 
              return x.text == marketData.marketData[item].choices[key].text });
            if ( sel != null && sel.color ) {
              marketData.marketData[item].choices[key].color = sel.color;
            }
          }
        } 
      }
      this.basicColumnData = marketData.marketData;
       /*  for (let item = 0; item < marketData.choices.length; item++) {
        const findMarketFilter = marketData.marketData.find(
          x => {

            delete x.color;
            if (marketData.choices[item].id === x.key) {
              x.color = marketData.choices[item].color;
              return true;
            } else {
              return false;
            }
          }
        );
        marketDataChildChoiceMapping.push({
          ...marketData.choices[item],
          ...findMarketFilter
        });
      }  */
    }
    if (marketData && marketData.graphType.graphType == "bubble_chart") {
      this.bubbleChartSeriesData = marketData.marketData.map(item => {
        return {
          x: item.momentum,
          y: item.executionCapabalities,
          z: (item.installBase / 2),
          name: item.text,
          cusomterExp: item.cusomterExp,
          docCount: item.docCount,
          color: this.bubleColorService.getBubleColor(item.cusomterExp)
        };
      });
      const maxX = this.bubbleChartSeriesData.reduce((prev, current) => (prev.x > current.x) ? prev : current);
      const maxY = this.bubbleChartSeriesData.reduce((prev, current) => (prev.y > current.y) ? prev : current);
      const maxXZ = maxX.z;
      const maxYZ = maxY.z;
      this.maxXValue = maxX.x + maxXZ;
      this.maxYValue = maxY.y + maxYZ;

      this.bubbleChartMarketData = marketData;
      this.generateBubbleChart(this.maxXValue, this.maxYValue);
    } else if (marketData && marketData.graphType.graphType == "word_cloud") {
      this.wordChartSeriesData = marketData.marketData.map(item => {
        return {
          name: item.key,
          weight: item.doc_percentage || item.docCount
        };
      });

      this.bubbleChartMarketData = marketData;
      this.generateBubbleChart(this.maxXValue, this.maxYValue);
    }
    else {
      if ((marketData.content.X.isUserProfileData || marketData.content.Y.isUserProfileData) && marketData.choices !== undefined && marketData.choices.length === 0 && marketData.choiceOrder) {
        marketData.sortingOrder === "DESC" ? (marketData.userProfileDataChoices.values = _.orderBy(
          marketData.userProfileDataChoices.values,
          ["sequence"],
          ["desc"]
        ))
          : (marketData.userProfileDataChoices.values = _.orderBy(
            marketData.userProfileDataChoices.values,
            ["sequence"],
            ["asc"]
          ));

      }
      // if (
      //   marketData.requiredChoices &&
      //   marketData.choices.length > marketData.requiredChoices.length
      // ) {
      //   filteredMarketData = marketData.choices.filter(x =>
      //     marketData.requiredChoices.find(y => y == x.id)
      //   );
      // }
      // filteredMarketData.length==0 ? '': marketData.choices=filteredMarketData;
      if (
        marketData.content.Y.topType &&
        marketData.content.Y.topType.alphabeticalSorting === true
      ) {
        marketData.content.Y.topType.order === "DESC"
          ? (marketData.choices = _.orderBy(
            marketData.choices,
            ["text"],
            ["desc"]
          ))
          : (marketData.choices = _.orderBy(
            marketData.choices,
            ["text"],
            ["asc"]
          ));
      } else if (
        marketData.content.Y.topType &&
        marketData.content.Y.topType.choiceOrder === true
      ) {
        marketData.content.Y.topType.order === "DESC"
          ? (marketData.choices = _.orderBy(
            marketData.choices,
            ["sequence"],
            ["desc"]
          ))
          : (marketData.choices = _.orderBy(
            marketData.choices,
            ["sequence"],
            ["asc"]
          ));
      } else {
        // internal sorting fixes for TOM and sequence
        let marketDataChoiceMapping = [];
        if (marketData.graphType.graphType !== "stacked_bar" && (marketData.graphType.graphType === "bar" && marketData.methodOfOperation === 'Top Of Mind')) {
          if (marketData.xAxischoices && marketData.xAxischoices.length > 0) {
            marketData.choices = marketData.xAxischoices;
          } else {
            marketData.xAxischoices = marketData.choices;
          }
        }
        for (let item = 0; item < marketData.choices.length; item++) {
          const findMarketFilter = marketData.marketData.find(
            x => {
              delete x.color;
              if (marketData.choices[item].id === x.key) {
                x.color = marketData.choices[item].color;
                return true;
              } else {
                return false;
              }
            }
          );
          marketDataChoiceMapping.push({
            ...marketData.choices[item],
            ...findMarketFilter
          });
        }
        if (marketData.graphType.graphType !== "stacked_bar" && marketData.graphType.graphType !== "bar" || (marketData.graphType.graphType === "bar" && marketData.methodOfOperation === 'Top Of Mind')) {
          let filteredChoiceItem = marketDataChoiceMapping.filter(x => {
            return x.doc_count || x.doc_percentage;
          });
          filteredChoiceItem = _.orderBy(
            filteredChoiceItem,
            ["doc_count"],
            ["desc"]
          );
          filteredChoiceItem = _.orderBy(
            filteredChoiceItem,
            ["doc_percentage"],
            ["desc"]
          );
          marketData.choices = filteredChoiceItem;
        } if (marketData.graphType.graphType === "bar" && marketData.methodOfOperation !== 'Top Of Mind') {
          marketData.choices = _.orderBy(
            marketDataChoiceMapping,
            ["doc_percentage"],
            ["desc"]
          );
        }
      }
    }


    //check user profile in x axis and single choice in y
    if (marketData.content.X && marketData.content.X.isUserProfileData && marketData.content.Y && marketData.content.Y.singleChoice) {
      marketData.graphType.title = 'Stacked bar';
    }
    this.marketData = marketData;
    if (this.marketData.choices && this.marketData.choices.length === 0) {
      this.marketData.marketData = this.marketData.marketData.map(x => {
        x.responseText = x.responseText || x.key;
        x.text = x.text || x.key;
        x.id = x.id || x.key;
        return x;
      });
    }
    // numeric bechenmark choice plot
    if (this.marketData.userBenchmark && this.marketData.userBenchmark.againstAll) {
      if (this.marketData.content.X && this.marketData.content.Y) {
        let top = this.marketData.content.Y.top || this.marketData.content.X.top;
        if (top < this.marketData.marketData.length) {
          const selectedUserChoice = this.marketData.marketData.find(x => x.userChoice);
          const selectedChoiceDataIndex = this.marketData.choices.findIndex(x => x.id === selectedUserChoice.key);
          this.marketData.choices.unshift(this.marketData.choices[selectedChoiceDataIndex]);
          this.marketData.choices.splice(selectedChoiceDataIndex + 1, 1);
        }
      }
    }
    //end numeric benchmark choice plot

    //need to change export function
    var json =
      marketData.graphType.title == 'Bar' ? this.generateBarChart() :
        marketData.graphType.title == 'Line chart' ? this.generateLineChart() :
          marketData.graphType.title == 'Pie' ? this.generatePieChart() :
            marketData.graphType.title == 'Word Cloud' ? this.generateWordCloudChart() :
              marketData.graphType.title == 'Basic column' ? this.generateBaseColumnChart() :
                marketData.graphType.title == 'Matrix Stack bar' ? this.generateMatrixStackedBarChart() :
                  (marketData.graphType.title == 'Stacked bar' && !marketData.isDualAxisQuestion) ? this.generateStackedBarChart() :
                    (marketData.graphType.title == 'Stacked bar' && marketData.isDualAxisQuestion) ? this.generateStackedBarChartWithDualAxis() :
                      marketData.graphType.title == 'Gauge' ? this.generateGaugeChart() :
                        marketData.graphType.title == 'Bubble chart' ? this.generateBubbleChart(this.maxXValue, this.maxYValue) :
                          marketData.graphType.title == 'Heat map' ? this.generateHeatMapChart() :
                            marketData.graphType.title == 'Doughnut' ? this.generatDonutChart() :
                              marketData.graphType.title == 'Semi Doughnut' ? this.generatSemiDonutChart() :
                                marketData.graphType.title == 'Spider chart' ? this.generateSpiderMapChart() :
                                  marketData.graphType.title == 'Tree Map' ? this.generateTreeMapChart() :
                                    marketData.graphType.title == 'Pivot' ? this.generatePivotChart() :
                                      marketData.graphType.title == 'Combination chart' ? this.getCombinationChart() :
                                        marketData.graphType.title == 'Scatter plot' ? this.generateScatterPlotChart() :
                                          marketData.graphType.title == 'Multi Line chart' ? this.generateMultipleLineChart() :
                                            marketData.graphType.title == 'Matrix Multi Line' ? this.generateMultipleLineChart() :
                                              null


    return Observable.of(json);
  }

  isEmpty(data?: any) {
    for (var key in data) {
      if (data.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  generateLineChart() {
    let localMarketData = this.marketData;
    let reponseNumber = this.marketData.numberOfResponse;
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    var json = {
      chart: {
        type: 'line'
        // events: {
        //   load: function() {
        //     if (localMarketData.setMessage === true) {
        //       this.renderer.text('Sample size too low,<br> check back in the future ', 150, 130, 100, 25)
        //       .css({ fontSize: '30px', color: '#000000', fontFamily: 'Montserrat' }).add();
        //     }
        //   }
        // }
      },
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal'
            }
          }
        }]
      },
      legend: {
        align: 'center',
        itemMarginBottom: 8,
        verticalAlign: 'bottom',
        layout: 'horizontal'
      },
      title: {
        text: this.marketData.title
      },
      yAxis: {
        title: {
          text: this.marketData.labels.yAxis
        }
      },
      xAxis: {
        categories: ' ',
        title: {
          text: this.marketData.labels.xAxis
        }
      },
      series: [{
        name: this.marketData.methodOfOperation,
        data: this.generateLineChartXY(),
      }],
      exporting: {
        allowHTML: true,
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + reponseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '7px',
                fontFamily: 'Montserrat',
                fontWeight: "normal"
              }
            }
          }],
          legend: {
            itemDistance: 50,
            y: this.DistanceCalculation(),
            itemStyle: {
              fontSize: '7px',
              fontFamily: 'Montserrat',
            }
          },
          title: {
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          xAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          yAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }}
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          }
        }
      },
    }
    return json
  }



  generateLineChartXY() {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let mapedColor: Array<any> = [];
    let seriesData: Array<object> = [];

    this.marketData.choices.forEach(choices => {
      this.marketData.marketData.forEach(docCount => {
        if (choices.id == docCount.key) {
          mapedColor.push(choices.color);
          mapedText.push(choices.text);
          mapedData.push(this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : docCount.doc_count);
          seriesData.push({
            name: choices.text,
            color: choices.color,
            y: this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : docCount.doc_count
          })
        }
      });
    });
    returnData = seriesData
    return returnData;
  }

  generatePivotChart() {

  }

  generateBarChart() {
    let iscapexOpex = false;
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    if (this.marketData.methodOfOperation === 'Mean' && this.marketData.content['X'].isMatrix === true && this.marketData.graphType.graphType === 'bar') {
      _.forEach(this.marketData.marketData, (marObj) => {
        marObj.iscapexOpex = true;
      });
    }
    let localMarketData = this.marketData;
    var json = {
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal'
            }
          }
        }]
      },
      chart: {
        renderTo: 'container',
        type: 'column',
      },
      legend: {
        align: 'center',
        itemMarginBottom: 4,
        itemMarginTop: 4,
        verticalAlign: 'bottom',
        layout: 'horizontal'
      },
      title: {
        text: this.marketData.title
      },
      tooltip: {
        pointFormat: this.getBarGraphToolTip(this.marketData)
      },
      yAxis: {
        title: {
          text: this.marketData.labels.yAxis
        }
      },
      xAxis: {
        categories: ' ',
        title: {
          text: this.marketData.labels.xAxis
        }
      },
      series: this.generateBarChartXY('both'),
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            pointWidth: 10,
            groupPadding: 0,
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: localMarketData.marketData.length <= 10 ? '10px' : (localMarketData.marketData.length > 10 && localMarketData.marketData.length < 20) ? '5px' : (localMarketData.marketData.length >= 20 && localMarketData.marketData.length < 30) ? '4px' : '3px',
                  fontWeight: localMarketData.marketData.length <= 10 ? "normal" : localMarketData.marketData.length > 10 ? "bold" : 'bold',
                  fontFamily: 'Montserrat',
                },
                format: '{point.y:.1f}%'
              }
            }
          },
          subtitle: {
            text: 'N=' + localMarketData.numberOfResponse,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: localMarketData.marketData.length <= 10 ? '10px' : localMarketData.marketData.length > 10 ? '3px' : '3px',
                fontFamily: 'Montserrat',
                fontWeight: localMarketData.marketData.length <= 10 ? "normal" : localMarketData.marketData.length > 10 ? "bold" : 'bold',
              },
              format: '{point.y:.1f}%'
            }
          }],
          legend: {
            itemDistance: 50,
            y: this.DistanceCalculation(),
            itemMarginBottom: 2,
            itemMarginTop: 2,
            maxHeight: 145,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            navigation: {
              activeColor: '#fff',
              inactiveColor: '#fff',
              style: {
                color: '#fff'
              }
            }
          },
          title: {
            x: 10,
            y : 30,
            
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          xAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          yAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                else {
                  if (localMarketData.userFilteredDataCN != undefined) {
                    this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.mapKeys(localMarketData, (value, key) => {
                      switch (key) {
                        case 'customFilteredChoiceNameValueAdoption':
                          this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDataSubDomainNameValue':
  
                          this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDataCountryNameValue':
  
                          this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDataEmployeeValue':
                          this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDatageographyNameValue':
                          this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDataindustryNameValue':
                          this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDataitBudgetNameValue':
                          this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDatajobTitleNameValue':
                          this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'userFilteredDatalineOfBusinessNameValue':
                          this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        case 'customFilteredChoiceNameValue':
                          this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;
                          break;
                        default: break;
                      }
                    });
                  }
                }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json
  }
  DistanceCalculation() {
    let localMarketData = this.marketData;
    let yDistance = 0;
    if (localMarketData.userFilteredDataCN == undefined) {
      yDistance = -100;
    }
    else {
      yDistance = -100;
      _.forEach(localMarketData.userFilteredDataCN, (data) => {
        if (data.length > 0) {
          yDistance -= 25;
        }
      });
    }
    return yDistance;
  }
  generateBarChartXY(type: any) {
    let returnData: any = {}
    let seriesData: Array<object> = [];

    let userClickStatus: boolean = false;
    this.marketData.choices.forEach(choices => {
      this.marketData.marketData.forEach((docCount: any) => {
        if (docCount.userChoice == true) {
          userClickStatus = true;
        };
      });
    });
    // check the mine vs organinsation bench mark graph
    if (this.marketData.choices.length > 0 && this.marketData.content.userBenchmark &&
      this.marketData.content.userBenchmark.isNumericBenchMark && this.marketData.content.userBenchmark.myOrgVsMarket) {
      if (this.marketData.content.userBenchmark.againstAll) {
        seriesData.push({
          name: `${this.marketData.marketData[0].text} (Your Choice)`,
          data: [this.marketData.marketData[0].doc_count],
          borderColor: '#000000',
          borderWidth: 5,
          label: 'Your Choice',
          dataLabels: {
            className: 'highlight',
            enabled: true,
            y: -10,
            formatter: function () {
              return 'Your Choice';
            }
          }
        })
      } else {
        seriesData.push({
          name: this.marketData.marketData[0].text,
          data: [this.marketData.marketData[0].doc_count]
        })
      }

    }
    else if (this.marketData.choices.length > 0) { //user profile data in y axis
      if (this.marketData.isClustered) {
        this.marketData.choices = _.orderBy(
          this.marketData.choices,
          ["sequence"],
          ["asc"]
        )
      }
      this.marketData.choices.forEach(choices => {
        this.marketData.marketData.forEach(docCount => {
          if ((choices.id == docCount.key) && userClickStatus == true) {
            if (docCount.userChoice) {
              seriesData.push({
                name: `${choices.text} (Your Choice)`,
                data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count],
                color: choices.color,
                borderColor: '#000000',
                borderWidth: 5,
                label: 'Your Choice',
                dataLabels: {
                  className: 'highlight',
                  enabled: true,
                  y: -10,
                  formatter: function () {
                    return 'Your Choice';
                  }
                }
              })
            } else if (!docCount.userChoice) {
              if (docCount.doc_percentage || docCount.doc_count) {
                seriesData.push({
                  name: choices.text,
                  color: choices.color,
                  data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count]
                })
              }
            }
          } else if ((choices.id == docCount.key) && userClickStatus == false) {
            if (docCount.userChoice && (this.marketData.content.userBenchmark) && (this.marketData.content.userBenchmark.realBenchmark)) {
              seriesData.push({
                name: `${choices.text} (Your Choice)`,
                data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count],
                color: '#FF0000',
                borderColor: '#000000',
                borderWidth: 5,
                dataLabels: {
                  className: 'highlight',
                  enabled: true,
                  y: -10,
                  formatter: function () {
                    return 'Your Choice';
                  }
                }
              })
            } else {
              seriesData.push({
                name: choices.text,
                color: choices.color,
                data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count]
              })
            }
          }
        });
      });
      // tslint:disable-next-line:max-line-length
    } else if (this.marketData.userProfileDataChoices && (!this.isEmptyObject(this.marketData.userProfileDataChoices)) &&
      this.marketData.userProfileDataChoices.values.length > 0) {
      if (this.marketData.isClustered) {
        this.marketData.userProfileDataChoices.values = _.orderBy(
          this.marketData.userProfileDataChoices.values,
          ["sequence"],
          ["asc"]
        )
      }
      this.marketData.userProfileDataChoices.values.forEach(userProfileDataChoices => {
        this.marketData.marketData.forEach(docCount => {
          if ((userProfileDataChoices.id == docCount.key) && userClickStatus == true) {
            if (docCount.userChoice) {
              seriesData.push({
                name: userProfileDataChoices.label,
                data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count],
                color: '#FF0000',
              })
            } else {
              seriesData.push({
                name: userProfileDataChoices.label,
                data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count],
                color: '#0000FF',
              })
            }
          } else if ((userProfileDataChoices.id == docCount.key) && userClickStatus == false) {
            seriesData.push({
              name: userProfileDataChoices.label,
              data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count]
            })
          }
        });
      });
    }
    else if (this.marketData.methodOfOperation === 'Mean' && this.marketData.content['X'].isMatrix === true && this.marketData.graphType.graphType === 'bar') {
      this.marketData.marketData.forEach(marObject => {
        seriesData.push({
          name: marObject.questionText,
          data: [this.marketData.methodOfOperation == 'Mean' ? marObject.mean : +marObject.doc_count]
        })
      });
    }
    else {
      this.marketData.marketData.forEach(docCount => {
        seriesData.push({
          name: docCount.text,
          data: [this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count]
        })
      });
    }
    returnData = seriesData ? seriesData : null
    return returnData;
  }

  generatePieChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    let reponseNumber = this.marketData.numberOfResponse;
    var json = {
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal'
            }
          }
        }]
      },
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: this.marketData.title
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          }
        }
      },
      series: [{
        name: 'Brands',
        colorByPoint: true,
        data: this.generatePieChartXY('both')
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                format: '{point.percentage:.1f} %',
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat'
                }
              }
            },
            pie: {
              showInLegend: true,
              dataLabels: {
                distance: -40
              }
            }
          },
          subtitle: {
            text: 'N=' + reponseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '7px',
                fontFamily: 'Montserrat'
              }
            }
          }],
          legend: {
            y: this.DistanceCalculation(),
            itemDistance: 50,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          title: {
            x: 10,
            y : 30,
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          },
        }
      }
    }

    return json
  }

  generatePieChartXY(type: any) {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let seriesData: any = [];

    this.marketData.choices.forEach(choices => {
      this.marketData.marketData.forEach(docCount => {
        if (choices.id == docCount.key) {
          mapedText.push(choices.text);
          mapedData.push(this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : docCount.doc_count)
          seriesData.push({
            name: choices.text,
            color: choices.color,
            y: this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : docCount.doc_count
          })
        }
      });
    });
    returnData = type == 'category' ? mapedText : type == 'data' ? mapedData : type == 'both' ? seriesData : null
    return returnData;
  }

  generateStackedBarChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    let reponseNumber = this.marketData.numberOfResponse;
    var json = {
      chart: {
        type: 'column'
      },
      title: {
        text: this.marketData.title
      },
      xAxis: {
        categories: this.generateStackedBarXAxis(),
        title: {
          text: this.marketData.labels.xAxis
        }
      },
      yAxis: {
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold'
          }
        },
        title: {
          text: this.marketData.labels.yAxis
        }
      },
      legend: {
        itemMarginBottom: 4,
        itemMarginTop: 4,
        align: 'center',
        verticalAlign: 'bottom',
        floating: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal:.0f}'
      },
      plotOptions: {
        column: {
          stacking: 'percent',
          dataLabels: {
            enabled: false
          }
        }
      },
      series: this.generateStakedBarDataSeries(),
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + reponseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '7px',
                fontFamily: 'Montserrat',
                fontWeight: "normal"
              }
            }
          }],
          legend: {
            y: this.DistanceCalculation() + 50,
            itemDistance: 50,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          title: {
            x: 10,
            y : 30,
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          xAxis: {
            title: {
              margin: 20,
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666',
                width: 70,
                textOverflow: 'ellipsis',
              }
            }
          },
          yAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else  {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  // generate matrix stacked bar
  generateMatrixStackedBarChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    let reponseNumber = this.marketData.numberOfResponse;
    var json = {
      chart: {
        type: 'column'
      },
      title: {
        text: this.marketData.title
      },
      xAxis: {
        categories: this.basicColumnData.map(x => x.questionText),
        title: {
          text: this.marketData.labels.xAxis
        }
      },
      yAxis: {
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold'
          }
        },
        title: {
          text: this.marketData.labels.yAxis
        }
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        floating: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}%<br/>Total: {point.stackTotal:.0f}'
      },
      plotOptions: {
        column: {
          stacking: 'percent',
          dataLabels: {
            enabled: false
          }
        }
      },
      series: this.toMatStackData(this.marketData.methodOfOperation),
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + reponseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          title: {
            x: 10,
            y : 30,
          },
        
          legend: {
            y: this.DistanceCalculation() + 75,
            itemDistance: 50,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'

          },
          xAxis: {
            title: {
              margin: 20,
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666',
                width: 70,
                textOverflow: 'ellipsis',
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }
  //end

  generateStackedBarXAxis() {
    let returnData: any;
    const seriesData: any = [];
    if (this.marketData.content["X"].isSolutionData === true) {
      this.marketData.marketData.forEach(element => {
        seriesData.push(element['title']);
      });
      returnData = seriesData ? seriesData : null; //to fix issue of label sorting of solution on xaxis

    }
    else {
      this.marketData.marketData.forEach(element => {
        let selectedChoices: any;
        selectedChoices = _.find(this.marketData.userProfileDataChoices.values, function (choice) {
          if (choice.id === element.choice) {
            return choice;
          }
        });
        if (selectedChoices) {
          seriesData.push(selectedChoices['label']);
        }
      });
      returnData = seriesData ? seriesData.sort() : null; //to fix issue of label sorting of solution on xaxis
    }
    // this.marketData.userProfileDataChoices.values.forEach((choices: any, index) => {
    //   if (choices) {
    //     seriesData.push(`${choices.label}`)
    //   }
    // });
    return returnData;
  }

  generateStakedBarDataSeries() {
    let returnData: any = {}
    let mapedData: Array<any> = [];
    this.marketData.choices.forEach((choices: any) => {
      let seriesData: any = {};
      seriesData.name = choices.text
      seriesData.id = choices.id
      seriesData.color = choices.color;
      seriesData.data = []
      mapedData.push(seriesData);
    });
    if (this.marketData.content["X"]["isSolutionData"] === true) {
      this.marketData.marketData.forEach((marketDataChoices: any, index: any) => {
        this.marketData.choices.forEach((choices: any) => {
          mapedData.forEach((mapedDat: any) => {
            let findMaped: any = {};
            findMaped = _.find(this.marketData.marketData[index].grouping, ['key', mapedDat.id])
            if ((findMaped) && (mapedDat.id == choices.id)) {
              mapedDat.data.push((this.marketData.methodOfOperation == 'Percentage' || this.marketData.methodOfOperation == 'Proportion') ? findMaped.doc_percentage : +findMaped.doc_count)
            } else if ((mapedDat.id == choices.id)) {
              mapedDat.data.push(0)
            }
          });
        });

      })


    } else {
      if (this.marketData.userProfileDataChoices.values) {
        this.marketData.userProfileDataChoices.values.forEach((choices: any) => {
          if (choices) {
            this.marketData.marketData.forEach((marketDataChoices: any, index: any) => {
              if (choices.id == marketDataChoices.choice) {
                this.marketData.choices.forEach((choices: any) => {
                  mapedData.forEach((mapedDat: any) => {
                    let findMaped: any = {};
                    findMaped = _.find(this.marketData.marketData[index].grouping, ['key', mapedDat.id])
                    if ((findMaped) && (mapedDat.id == choices.id)) {
                      mapedDat.data.push((this.marketData.methodOfOperation == 'Percentage' || this.marketData.methodOfOperation == 'Proportion') ? findMaped.doc_percentage : +findMaped.doc_count)
                    } else if ((mapedDat.id == choices.id)) {
                      mapedDat.data.push(0)
                    }
                  });
                });
              }
            })
          }
        })
      }
    }
    returnData = mapedData ? mapedData : null
    return returnData;
  }
  generateMultipleLineChart() {
    var self = this;
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    var color = [];
    // for(var item in gDataList) {
     if(this.basicColumnData.length > 0 && this.basicColumnData[0].choices != null ) {
       color = this.basicColumnData[0].choices.map((obj, i)=> {
        return (obj.color != null && obj.color.trim() != '') ? obj.color: self.setBg(i);
       });
     }
     
    let json: any = {
      colors: color,
      chart: {
        type: 'line'
      },
      title: {
        text: this.marketData.title
      },
      xAxis: {
        categories: this.generateMatrixMultiLineXAxis()
      },
      yAxis: {
        min: 0,
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold'
          }
        }
      },
      tooltip: {
        backgroundColor: {
          linearGradient: [0, 0, 0, 60],
          stops: [
            [0, '#FFFFFF'],
            [1, '#E0E0E0']
          ]
        },
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}%<br/>',
        borderWidth: 1,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          label: {
            enabled: false,
        },
          enableMouseTracking: true
        }
      },
      legend: {
        itemMarginBottom: 14,
        itemMarginTop: 4,
        align: 'center',
        verticalAlign: 'bottom',
        floating: false
      },
      series: this.generateMatrixMultiLineDataSeries(this.marketData.methodOfOperation),
      showInLegend: false,

      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          title: {
            x: 10,
            y : 30,
          },
          legend: {
            y: this.DistanceCalculation() + 75,
            itemDistance: 50,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });

                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }
  generateStackedBarChartWithDualAxis() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    let reponseNumber = this.marketData.numberOfResponse;
    var json = {
      chart: {
        type: 'column'
      },
      title: {
        text: this.marketData.title
      },
      xAxis: {
        categories: this.generateStackedBarDualAxis_XAxis(),
        title: {
          text: this.marketData.labels.xAxis
        }
      },
      yAxis: {
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold'
          }
        },
        title: {
          text: this.marketData.labels.yAxis
        }
      },
      legend: {
        itemMarginBottom: 4,
        itemMarginTop: 4,
        align: 'center',
        verticalAlign: 'bottom',
        floating: false
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}%<br/>Total: {point.stackTotal:.0f}'
      },
      plotOptions: {
        column: {
          stacking: 'percent',
          dataLabels: {
            enabled: false
          }
        }
      },
      series: this.generateStakedBarDualAxisDataSeries(),
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + reponseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
           title: {
            x: 10,
            y : 30,
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '7px',
                fontFamily: 'Montserrat',
                fontWeight: "normal"
              }
            }
          }],
          legend: {
            y: this.DistanceCalculation() + 75,
            itemDistance: 50,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          xAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          yAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generateStackedBarDualAxis_XAxis() {
    let returnData: any;
    let seriesData: any = [];
    let filteredChoiceData = this.marketData.xAxischoices.filter(x => {
      return this.marketData.marketData.findIndex(y => y.choice === x.id) > -1;
    });
    filteredChoiceData.forEach((choices: any, index) => {
      if (choices) {
        seriesData.push(`${choices.text}`)
      }
    });
    returnData = seriesData ? seriesData : null
    return returnData;
  }

  generateStakedBarDualAxisDataSeries() {
    let returnData: any = {}
    let mapedData: Array<any> = [];
    this.marketData.marketData.forEach((marketChoices: any, index: any) => {
      marketChoices.grouping.forEach((innerObject) => {
        _.filter(this.marketData.choices, (choiceInnerObj) => {
          if (choiceInnerObj.id == innerObject.key) {
            let seriesData: any = {};
            seriesData.name = choiceInnerObj.text
            seriesData.color = choiceInnerObj.color;
            seriesData.id = choiceInnerObj.id
            seriesData.data = []
            mapedData.push(seriesData);
          }
        });
      });
    });

    mapedData = _.uniqWith(mapedData, _.isEqual);
    this.marketData.xAxischoices.forEach((choices: any) => {
      if (choices) {
        this.marketData.marketData.forEach((marketDataChoices: any, index: any) => {
          if (choices.id == marketDataChoices.choice) {
            this.marketData.choices.forEach((choices: any) => {
              mapedData.forEach((mapedDat: any) => {
                let findMaped: any = {};
                findMaped = _.find(this.marketData.marketData[index].grouping, ['key', mapedDat.id])
                if ((findMaped) && (mapedDat.id == choices.id)) {
                  mapedDat.data.push((this.marketData.methodOfOperation == 'Percentage' || this.marketData.methodOfOperation == 'Proportion') ? findMaped.doc_percentage : +findMaped.doc_count)
                } else if ((mapedDat.id == choices.id)) {
                  mapedDat.data.push(0)
                }
              });
            });
          }
        })
      }
    })
    returnData = mapedData ? mapedData : null
    //Order based on sequence begin
    if (this.marketData.graphType.graphType === 'stacked_bar' && returnData !== null) {
      _.forEach(returnData, (mapedDataObj) => {
        const sequenceObj = _.find(this.marketData.choices, { 'id': mapedDataObj.id });
        if (sequenceObj) {
          mapedDataObj.sequence = sequenceObj.sequence;
        }
      });
      returnData = _.orderBy(returnData, ['sequence'], ['asc']);
    }
    //Order based on sequence ends
    return returnData;
  }

  generatSemiDonutChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    let reponseNumber = this.marketData.numberOfResponse;
    let json: any = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
      },
      title: {
        text: this.marketData.title
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: 0,
            style: {
              color: 'black'
            }
          },
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '75%']
        }
      },
      series: [{
        type: 'pie',
        name: 'Percentage',
        innerSize: '50%',
        data: this.generateSemiDonutChartXY('both')
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: false
              }
            },
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.percentage:.1f} %',
                // distance: -25,
                // connectorColor:  'black',
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                },
              }
            }
          },
          subtitle: {
            text: 'N=' + reponseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          legend: {
            y: this.DistanceCalculation(),
            itemDistance: 50,
            itemStyle: {
              fontSize: '7px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          title: {
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generateSemiDonutChartXY(type: any) {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let seriesData: Array<object> = [];

    // cheking profile data choice or not
    if (this.marketData.choices.length > 0) {
      this.marketData.choices.forEach(choices => {
        this.marketData.marketData.forEach(docCount => {
          if (choices.id == docCount.key) {
            mapedText.push(choices.text);
            mapedData.push(docCount.doc_count)
            seriesData.push({
              name: choices.text,
              y: +docCount.doc_count,
              color: choices.color
            })
          }
        });
      });
    }
    // if it is userprofile based graph
    // tslint:disable-next-line:max-line-length
    else if (this.marketData.userProfileDataChoices && (!this.isEmptyObject(this.marketData.userProfileDataChoices)) && this.marketData.userProfileDataChoices.values.length > 0) {
      this.marketData.userProfileDataChoices.values.forEach(choices => {
        this.marketData.marketData.forEach(docCount => {
          if (choices.id == docCount.key) {
            mapedText.push(choices.label);
            mapedData.push(docCount.doc_count)
            seriesData.push({
              name: choices.label,
              y: +docCount.doc_count,
              color: choices.color
            })
          }
        });
      });
    }

    returnData = type == 'category' ? mapedText : type == 'data' ? mapedData : type == 'both' ? seriesData : null
    return returnData;
  }

  generateTreeMapChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    let json: any = {
      // colorAxis: {
      //   minColor: '#fee3e2',
      //   maxColor: '#fb625c'
      // },
      series: [{
        type: 'treemap',
        layoutAlgorithm: 'squarified',
        data: this.generateTreeMapChartXY()
      }],
      chart: {
      },
      plotOptions: {
        treemap: {
          dataLabels: {
            enabled: true,
            distance: 0,
            style: {
              color: 'white',
              textOutline: '1px contrast'
            }
          }
        }
      },
      title: {
        text: this.marketData.title
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          title: {
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '7px',
                fontFamily: 'Montserrat',
                fontWeight: "normal"
              }
            }
          }],
          legend: {
            y: this.DistanceCalculation(),
            itemDistance: 50,
            itemStyle: {
              fontSize: '7px',
              fontFamily: 'Montserrat'
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generateTreeMapChartXY() {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let seriesData: Array<object> = [];
    let sortedData: Array<object> = [];
    let randomNumberArray = [1.5, 2.1, 2.2, 2.3, 2.4, 2.7, 2.8, 2.9, 3, 3.5, 4, 4, 5, 2.6, 2, 8, 3.8, 6, 6.4, 4.2, 4.3]
    let randomIndex = 1;
    this.marketData.marketData.forEach(docCount => {
      randomIndex += 1;
      mapedText.push(docCount.text);
      mapedData.push(docCount.doc_percentage)
      if (randomIndex > randomNumberArray.length) {
        randomIndex = 1;
      }
      seriesData.push({
        name: docCount.text,
        value: docCount.doc_percentage,
        // colorValue: docCount.doc_percentage,
        //  color: this.bubleColorService.getRandomColor(randomNumberArray[randomIndex])
        color: this.setTreeMapColor(this.marketData.choices, docCount, randomNumberArray[randomIndex])

      })
    });
    function compareArray(a, b) { // method to sort heat map data to assign color
      const genreA = a.value
      const genreB = b.value
      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    }
    seriesData.sort(compareArray);
    seriesData.forEach((data: any, index: any) => {
      data.colorValue = (index);
    });
    returnData = seriesData ? seriesData : null
    return returnData;
  }

  generateSpiderMapChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    let json: any = {
      chart: {
        polar: true,
        type: 'line',
        marginBottom: 50
            },
      title: {
        text: this.marketData.title
      },
      pane: {
        size: '80%'
      },
      xAxis: {
        categories: this.generateSpiderMapChartXY('categories'),
        tickmarkPlacement: 'on',
        lineWidth: 0
      },
      yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0
      },
      tooltip: {
        shared: true,
        pointFormat: '<span style="color:{series.color}">{series.name}: <b>${point.y:,.0f}</b><br/>'
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        y: 25,
        layout: 'horizontal'
      },
      series: [{
        name: 'Allocated Budget',
        data: this.generateSpiderMapChartXY('data'),
        pointPlacement: 'on'
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          legend: {
            y: this.DistanceCalculation()
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generateSpiderMapChartXY(data: any) {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let seriesData: Array<object> = [];

    this.marketData.choices.forEach(choices => {
      this.marketData.marketData.forEach(docCount => {
        if (choices.id == docCount.key) {
          mapedText.push(choices.text);
          mapedData.push(docCount.doc_count)
          if (data == 'categories') {
            seriesData.push(choices.text)
          } else if (data == 'data') {
            seriesData.push(docCount.doc_count)
          }
        }
      });
    });
    returnData = seriesData ? seriesData : null
    return returnData;
  }

  // Format to heat data
  toHeatData(yChoices: Array<string>, heatGraphData: any, operation: string) {
    let xChoices = [];
    const heatData = [];
    if (operation === 'Frequency') {
      heatGraphData = _.sortBy(heatGraphData, ['choiceText']);
      xChoices = _.map(heatGraphData, 'choiceText');
      _.forEach(xChoices, function (xAxisvalue, xAxisKey) {
        const choiceData: any = _.find(heatGraphData, { 'choiceText': xAxisvalue });
        _.forEach(yChoices, function (yAxisvalue, yAxisKey) {
          if (choiceData && choiceData.repeatCount[yAxisvalue]) {
            heatData.push([xAxisKey, yAxisKey, choiceData.repeatCount[yAxisvalue]]);
          } else {
            heatData.push([xAxisKey, yAxisKey, 0]);
          }
        });
      });
    }
    return {
      xChoices: xChoices,
      heatData: heatData
    };
  }

  generateHeatMapChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    const secondaryChoices = _.sortBy(this.marketData.choices, ['sequence']);
    const yCategories: Array<string> = _.map(secondaryChoices, 'text');
    const heatDataObj = this.toHeatData(yCategories, this.marketData.marketData, this.marketData.methodOfOperation);
    const heatData = heatDataObj.heatData;
    const xCategories = heatDataObj.xChoices;

    let json: any = {
      chart: {
        type: 'heatmap',
        marginTop: 40,
        marginBottom: 80,
        plotBorderWidth: 1
      },
      title: {
        text: this.marketData.title
      },
      xAxis: {
        categories: xCategories
      },
      yAxis: {
        categories: yCategories,
        title: null
      },
      colorAxis: {
        min: 0,
        minColor: '#FFFFFF',
        maxColor: '#FF0000'
      },
      legend: {
        align: 'right',
        layout: 'vertical',
        margin: 0,
        verticalAlign: 'top',
        y: 25,
        symbolHeight: 280
      },
      tooltip: {
        formatter: function () {
          return (
            this.series.xAxis.categories[this.point.x] +
            "</b> <br><b>" +
            this.series.yAxis.categories[this.point.y] +
            "</b>: <b>" +
            this.point.value +
            "</b>"
          );
        }
      },
      series: [{
        name: '',
        borderWidth: 1,
        data: heatData,
        dataLabels: {
          enabled: true,
          color: '#000000'
        }
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          legend: {
            y: this.DistanceCalculation()

          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generatDonutChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    let json: any = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
      },
      title: {
        text: this.marketData.title
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        itemMarginBottom: 4,
        itemMarginTop: 4
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
            style: {
              color: 'black'
            }
          },
          showInLegend: true,
          allowPointSelect: false,
          point: {
            events: {
              legendItemClick: function (e) {
                e.preventDefault();
              }
            }
          },
          startAngle: 0,
          endAngle: 0,
          center: ['50%', '50%'],
          size: '100%'
        }
      },
      series: [{
        type: 'pie',
        name: 'Percentage',
        innerSize: '50%',
        data: this.generateSemiDonutChartXY('both')
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat'
                },
              }
            },
            pie: {
              dataLabels: {
                enabled: true,
                format: '{point.percentage:.1f} %',
                // distance: -25,
                // connectorColor:  'black',
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                },
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          legend: {
            y: this.DistanceCalculation(),
            itemDistance: 50,
            itemStyle: {
              fontSize: '10px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          title: {
            x: 10,
            y : 30,
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generateDonutChartXY(type: any) {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let seriesData: Array<object> = [];

    this.marketData.choices.forEach(choices => {
      this.marketData.marketData.forEach(docCount => {
        if (choices.id == docCount.key) {
          mapedText.push(choices.text);
          mapedData.push(this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count)
          seriesData.push({
            name: choices.text,
            y: this.marketData.methodOfOperation == 'Percentage' ? docCount.doc_percentage : +docCount.doc_count
          })
        }
      });
    });
    returnData = type == 'category' ? mapedText : type == 'data' ? mapedData : type == 'both' ? seriesData : null
    return returnData;
  }

  generateGaugeChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    let json: any = {
      chart: {
        type: 'solidgauge'
      },
      title: {
        text: this.marketData.title
      },
      pane: {
        center: ['50%', '85%'],
        size: '100%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: '#EEE',
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },
      tooltip: {
        enabled: false
      },
      yAxis: {
        stops: [
          [0.1, '#55BF3B'], // green
          [0.5, '#DDDF0D'], // yellow
          [0.9, '#DF5353'] // red
        ],
        lineWidth: 0,
        minorTickInterval: null,
        tickAmount: 2,
        title: {
          y: -70,
          text: 'Speed'
        },
        labels: {
          y: 16
        },
        min: 0,
        max: 200
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true
          }
        }
      },
      series: [{
        name: 'Speed',
        data: [0],
        dataLabels: {
          format: '<div style="text-align:center"><span style="font-size:25px;color:' +
            ('black') + '">{y}</span><br/>' +
            '<span style="font-size:12px;color:silver">km/h</span></div>'
        },
        tooltip: {
          valueSuffix: ' km/h'
        }
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          legend: {
            y: this.DistanceCalculation()

          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      },
      data: this.marketData
    };
    return json;
  }

  generateBubbleChart(maxXValue, maxYValue) {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    let json: any = {
      chart: {
        type: 'bubble',
        plotBorderWidth: 1,
        zoomType: 'xy'
      },

      legend: {
        enabled: false
      },

      title: {
        text: this.bubbleChartMarketData.title,
      },

      xAxis: {
        max: 1.1,
        min: -0.1,
        gridLineWidth: 0,
        title: {
          text: 'Momentum '
        },
        labels: {
          formatter: function () {
            if (this.isLast) {
              return 'High'
            } else if (this.isFirst) {
              return 'Low'
            } else {
              return ''
            }
          }
        },
        startOnTick: false,
        endOnTick: false,
        tickWidth: 0,
        plotLines: [
          {
            color: "#CCCCCC",
            dashStyle: "line",
            width: 1,
            value: 0.5,
            // label: {
            //   rotation: 0,
            //   y: 15,
            //   x: 160,
            //   style: {
            //     color: "#dc0d05"
            //   },
            //   text: "The Pace Setters "
            // },
            zIndex: 9
          },
          {
            color: "#fff",
            dashStyle: "line",
            width: 0,
            value: 1,
            // label: {
            //   rotation: 0,
            //   align: "right",
            //   style: {
            //     color: "#dc0d05"
            //   },
            //   text: "The Marketers",
            //   y: 290
            // },
            zIndex: 6
          }
        ]
      },

      yAxis: {
        max: 1.1,
        min: -0.1,
        gridLineWidth: 0,
        startOnTick: false,
        endOnTick: false,
        tickWidth: 0,
        title: {
          text: 'Execution Capabilities'
        },
        labels: {
          formatter: function () {
            if (this.isLast) {
              return 'High'
            } else if (this.isFirst) {
              return 'Low'
            } else {
              return ''
            }
          },
          rotation: -90,
        },
        plotLines: [
          {
            color: "#CCCCCC",
            dashStyle: "line",
            width: 1,
            value: 0.5,
            // label: {
            //   align: "left",
            //   style: {
            //     color: "#dc0d05"
            //   },
            //   text: "The Inerts",
            //   y: 145,
            //   x: 4
            // },
            zIndex: 0
          },
          {
            color: "#fff",
            dashStyle: "line",
            width: 0,
            value: 1,
            // label: {
            //   align: "left",
            //   style: {
            //     color: "#dc0d05"
            //   },
            //   text: "The High Potentials",
            //   y: 5
            // },
            zIndex: 6
          }
        ],
        maxPadding: 0.2
      },

      tooltip: {
        useHTML: true,
        enabled: false,
        headerFormat: "<table>",
        pointFormat:
          '<tr><th colspan="2"><h3>{point.name}</h3></th></tr>' +
          "<tr><th>Momentum:</th><td>{point.x}</td></tr>" +
          "<tr><th>Execution Capabalities:</th><td>{point.y}</td></tr>" +
          "<tr><th>Install Base:</th><td>{point.z}</td></tr>" +
          "<tr><th>Customer Expectation:</th><td>{point.cusomterExp}</td></tr>",
        footerFormat: "</table>",
        followPointer: true
      },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{point.name}',
            useHTML: true,
            color: '#000',
            style: {
              fontWeight: 'normal'
            }
          },
          marker: {
            lineColor: '#000000'
          }
        }
      },

      series: [
        {
          data: this.bubbleChartSeriesData
        }
      ],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        legend: {
          y: this.DistanceCalculation()

        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                }
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '7px',
                fontFamily: 'Montserrat',
                fontWeight: "normal"
              }
            }
          }],
          title: {
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          xAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          yAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            },
            spacingBottom: 60
          }
        }
      }
    }
    return json;
  }

  getCombinationChart() {
    let json: any = {
      title: {
        text: this.marketData.title
      },
      xAxis: {
        categories: ['Apples', 'Oranges', 'Pears', 'Bananas', 'Plums']
      },
      labels: {
        items: [{
          html: 'Total fruit consumption',
          style: {
            left: '50px',
            top: '18px',
            color: 'black'
          }
        }]
      },
      series: [{
        type: 'column',
        name: 'Jane',
        data: [3, 2, 1, 3, 4]
      }, {
        type: 'column',
        name: 'John',
        data: [2, 3, 5, 7, 6]
      }, {
        type: 'column',
        name: 'Joe',
        data: [4, 3, 3, 9, 0]
      }, {
        type: 'spline',
        name: 'Average',
        data: [3, 2.67, 3, 6.33, 3.33],
        marker: {
          lineWidth: 2,
          lineColor: 'black',
          fillColor: 'white'
        }
      }, {
        type: 'pie',
        name: 'Total consumption',
        data: [{
          name: 'Jane',
          y: 13,
          color: 'blue'
        }, {
          name: 'John',
          y: 23,
          color: 'red'
        }, {
          name: 'Joe',
          y: 19,
          color: 'green'
        }],
        center: [100, 80],
        size: 100,
        showInLegend: false,
        dataLabels: {
          enabled: false
        }
      }]
    }
    return json;
  }

  generateWordCloudChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    var json: any = {
      series: [{
        type: 'wordcloud',
        data: this.wordChartSeriesData,
        name: 'Occurrences',
        style: {
          fontFamily: 'Arial'
        }
      }],
      title: {
        text: this.marketData.title,
      },
      chart: {
      },
      tooltip: {
        useHTML: true,
        enabled: false
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          title: {
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          legend: {
            y: this.DistanceCalculation()

          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }

  generateWordCloud() {
    let returnData: any = {}
    let mapedText: Array<String> = [];
    let mapedData: Array<any> = [];
    let seriesData: any = [];

    this.marketData.choices.forEach(choices => {
      this.marketData.marketData.forEach(docCount => {
        if (choices.id == docCount.key) {
          mapedText.push(choices.text);
          mapedData.push(docCount.doc_count)
          seriesData.push({
            name: choices.text,
            weight: docCount.doc_count
          })
        }
      });
    });
    returnData = seriesData ? seriesData : null
    return returnData;
  }

  generateScatterPlotChart() {
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    let json: any = {
      chart: {
        type: 'scatter',
        zoomType: 'xy',
        marginBottom: 70
      },
      title: {
        text: this.marketData.title
      },
      subtitle: {
        text: 'Source: Heinz  2003'
      },
      xAxis: {
        title: {
          enabled: true,
          text: 'Height (cm)'
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true
      },
      yAxis: {
        title: {
          text: 'Weight (kg)'
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        y: 15,
        floating: true,
        backgroundColor: '#FFFFFF',
        borderWidth: 1
      },
      plotOptions: {
        scatter: {
          marker: {
            radius: 5,
            states: {
              hover: {
                enabled: true,
                lineColor: 'rgb(100,100,100)'
              }
            }
          },
          states: {
            hover: {
              marker: {
                enabled: false
              }
            }
          },
          tooltip: {
            headerFormat: '<b>{series.name}</b><br>',
            pointFormat: '{point.x} cm, {point.y} kg'
          }
        }
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          legend: {
            y: this.DistanceCalculation()
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                  else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      },
      series: [{
        name: 'Female',
        color: 'rgba(223, 83, 83, .5)',
        data: [[161.2, 51.6], [167.5, 59.0], [159.5, 49.2], [157.0, 63.0], [155.8, 53.6],
        [170.0, 59.0], [159.1, 47.6], [166.0, 69.8], [176.2, 66.8], [160.2, 75.2],
        [172.5, 55.2], [170.9, 54.2], [172.9, 62.5], [153.4, 42.0], [160.0, 50.0],
        [147.2, 49.8], [168.2, 49.2], [175.0, 73.2], [157.0, 47.8], [167.6, 68.8],
        [159.5, 50.6], [175.0, 82.5], [166.8, 57.2], [176.5, 87.8], [170.2, 72.8],
        [174.0, 54.5], [173.0, 59.8], [179.9, 67.3], [170.5, 67.8], [160.0, 47.0],
        [154.4, 46.2], [162.0, 55.0], [176.5, 83.0], [160.0, 54.4], [152.0, 45.8],
        [162.1, 53.6], [170.0, 73.2], [160.2, 52.1], [161.3, 67.9], [166.4, 56.6],
        [168.9, 62.3], [163.8, 58.5], [167.6, 54.5], [160.0, 50.2], [161.3, 60.3],
        [167.6, 58.3], [165.1, 56.2], [160.0, 50.2], [170.0, 72.9], [157.5, 59.8],
        [167.6, 61.0], [160.7, 69.1], [163.2, 55.9], [152.4, 46.5], [157.5, 54.3],
        [168.3, 54.8], [180.3, 60.7], [165.5, 60.0], [165.0, 62.0], [164.5, 60.3],
        [156.0, 52.7], [160.0, 74.3], [163.0, 62.0], [165.7, 73.1], [161.0, 80.0],
        [162.0, 54.7], [166.0, 53.2], [174.0, 75.7], [172.7, 61.1], [167.6, 55.7],
        [151.1, 48.7], [164.5, 52.3], [163.5, 50.0], [152.0, 59.3], [169.0, 62.5],
        [164.0, 55.7], [161.2, 54.8], [155.0, 45.9], [170.0, 70.6], [176.2, 67.2],
        [170.0, 69.4], [162.5, 58.2], [170.3, 64.8], [164.1, 71.6], [169.5, 52.8],
        [163.2, 59.8], [154.5, 49.0], [159.8, 50.0], [173.2, 69.2], [170.0, 55.9],
        [161.4, 63.4], [169.0, 58.2], [166.2, 58.6], [159.4, 45.7], [162.5, 52.2],
        [159.0, 48.6], [162.8, 57.8], [159.0, 55.6], [179.8, 66.8], [162.9, 59.4],
        [161.0, 53.6], [151.1, 73.2], [168.2, 53.4], [168.9, 69.0], [173.2, 58.4],
        [171.8, 56.2], [178.0, 70.6], [164.3, 59.8], [163.0, 72.0], [168.5, 65.2],
        [166.8, 56.6], [172.7, 105.2], [163.5, 51.8], [169.4, 63.4], [167.8, 59.0],
        [159.5, 47.6], [167.6, 63.0], [161.2, 55.2], [160.0, 45.0], [163.2, 54.0],
        [162.2, 50.2], [161.3, 60.2], [149.5, 44.8], [157.5, 58.8], [163.2, 56.4],
        [172.7, 62.0], [155.0, 49.2], [156.5, 67.2], [164.0, 53.8], [160.9, 54.4],
        [162.8, 58.0], [167.0, 59.8], [160.0, 54.8], [160.0, 43.2], [168.9, 60.5],
        [158.2, 46.4], [156.0, 64.4], [160.0, 48.8], [167.1, 62.2], [158.0, 55.5],
        [167.6, 57.8], [156.0, 54.6], [162.1, 59.2], [173.4, 52.7], [159.8, 53.2],
        [170.5, 64.5], [159.2, 51.8], [157.5, 56.0], [161.3, 63.6], [162.6, 63.2],
        [160.0, 59.5], [168.9, 56.8], [165.1, 64.1], [162.6, 50.0], [165.1, 72.3],
        [166.4, 55.0], [160.0, 55.9], [152.4, 60.4], [170.2, 69.1], [162.6, 84.5],
        [170.2, 55.9], [158.8, 55.5], [172.7, 69.5], [167.6, 76.4], [162.6, 61.4],
        [167.6, 65.9], [156.2, 58.6], [175.2, 66.8], [172.1, 56.6], [162.6, 58.6],
        [160.0, 55.9], [165.1, 59.1], [182.9, 81.8], [166.4, 70.7], [165.1, 56.8],
        [177.8, 60.0], [165.1, 58.2], [175.3, 72.7], [154.9, 54.1], [158.8, 49.1],
        [172.7, 75.9], [168.9, 55.0], [161.3, 57.3], [167.6, 55.0], [165.1, 65.5],
        [175.3, 65.5], [157.5, 48.6], [163.8, 58.6], [167.6, 63.6], [165.1, 55.2],
        [165.1, 62.7], [168.9, 56.6], [162.6, 53.9], [164.5, 63.2], [176.5, 73.6],
        [168.9, 62.0], [175.3, 63.6], [159.4, 53.2], [160.0, 53.4], [170.2, 55.0],
        [162.6, 70.5], [167.6, 54.5], [162.6, 54.5], [160.7, 55.9], [160.0, 59.0],
        [157.5, 63.6], [162.6, 54.5], [152.4, 47.3], [170.2, 67.7], [165.1, 80.9],
        [172.7, 70.5], [165.1, 60.9], [170.2, 63.6], [170.2, 54.5], [170.2, 59.1],
        [161.3, 70.5], [167.6, 52.7], [167.6, 62.7], [165.1, 86.3], [162.6, 66.4],
        [152.4, 67.3], [168.9, 63.0], [170.2, 73.6], [175.2, 62.3], [175.2, 57.7],
        [160.0, 55.4], [165.1, 104.1], [174.0, 55.5], [170.2, 77.3], [160.0, 80.5],
        [167.6, 64.5], [167.6, 72.3], [167.6, 61.4], [154.9, 58.2], [162.6, 81.8],
        [175.3, 63.6], [171.4, 53.4], [157.5, 54.5], [165.1, 53.6], [160.0, 60.0],
        [174.0, 73.6], [162.6, 61.4], [174.0, 55.5], [162.6, 63.6], [161.3, 60.9],
        [156.2, 60.0], [149.9, 46.8], [169.5, 57.3], [160.0, 64.1], [175.3, 63.6],
        [169.5, 67.3], [160.0, 75.5], [172.7, 68.2], [162.6, 61.4], [157.5, 76.8],
        [176.5, 71.8], [164.4, 55.5], [160.7, 48.6], [174.0, 66.4], [163.8, 67.3]]
      }, {
        name: 'Male',
        color: 'rgba(119, 152, 191, .5)',
        data: [[174.0, 65.6], [175.3, 71.8], [193.5, 80.7], [186.5, 72.6], [187.2, 78.8],
        [181.5, 74.8], [184.0, 86.4], [184.5, 78.4], [175.0, 62.0], [184.0, 81.6],
        [180.0, 76.6], [177.8, 83.6], [192.0, 90.0], [176.0, 74.6], [174.0, 71.0],
        [184.0, 79.6], [192.7, 93.8], [171.5, 70.0], [173.0, 72.4], [176.0, 85.9],
        [176.0, 78.8], [180.5, 77.8], [172.7, 66.2], [176.0, 86.4], [173.5, 81.8],
        [178.0, 89.6], [180.3, 82.8], [180.3, 76.4], [164.5, 63.2], [173.0, 60.9],
        [183.5, 74.8], [175.5, 70.0], [188.0, 72.4], [189.2, 84.1], [172.8, 69.1],
        [170.0, 59.5], [182.0, 67.2], [170.0, 61.3], [177.8, 68.6], [184.2, 80.1],
        [186.7, 87.8], [171.4, 84.7], [172.7, 73.4], [175.3, 72.1], [180.3, 82.6],
        [182.9, 88.7], [188.0, 84.1], [177.2, 94.1], [172.1, 74.9], [167.0, 59.1],
        [169.5, 75.6], [174.0, 86.2], [172.7, 75.3], [182.2, 87.1], [164.1, 55.2],
        [163.0, 57.0], [171.5, 61.4], [184.2, 76.8], [174.0, 86.8], [174.0, 72.2],
        [177.0, 71.6], [186.0, 84.8], [167.0, 68.2], [171.8, 66.1], [182.0, 72.0],
        [167.0, 64.6], [177.8, 74.8], [164.5, 70.0], [192.0, 101.6], [175.5, 63.2],
        [171.2, 79.1], [181.6, 78.9], [167.4, 67.7], [181.1, 66.0], [177.0, 68.2],
        [174.5, 63.9], [177.5, 72.0], [170.5, 56.8], [182.4, 74.5], [197.1, 90.9],
        [180.1, 93.0], [175.5, 80.9], [180.6, 72.7], [184.4, 68.0], [175.5, 70.9],
        [180.6, 72.5], [177.0, 72.5], [177.1, 83.4], [181.6, 75.5], [176.5, 73.0],
        [175.0, 70.2], [174.0, 73.4], [165.1, 70.5], [177.0, 68.9], [192.0, 102.3],
        [176.5, 68.4], [169.4, 65.9], [182.1, 75.7], [179.8, 84.5], [175.3, 87.7],
        [184.9, 86.4], [177.3, 73.2], [167.4, 53.9], [178.1, 72.0], [168.9, 55.5],
        [157.2, 58.4], [180.3, 83.2], [170.2, 72.7], [177.8, 64.1], [172.7, 72.3],
        [165.1, 65.0], [186.7, 86.4], [165.1, 65.0], [174.0, 88.6], [175.3, 84.1],
        [185.4, 66.8], [177.8, 75.5], [180.3, 93.2], [180.3, 82.7], [177.8, 58.0],
        [177.8, 79.5], [177.8, 78.6], [177.8, 71.8], [177.8, 116.4], [163.8, 72.2],
        [188.0, 83.6], [198.1, 85.5], [175.3, 90.9], [166.4, 85.9], [190.5, 89.1],
        [166.4, 75.0], [177.8, 77.7], [179.7, 86.4], [172.7, 90.9], [190.5, 73.6],
        [185.4, 76.4], [168.9, 69.1], [167.6, 84.5], [175.3, 64.5], [170.2, 69.1],
        [190.5, 108.6], [177.8, 86.4], [190.5, 80.9], [177.8, 87.7], [184.2, 94.5],
        [176.5, 80.2], [177.8, 72.0], [180.3, 71.4], [171.4, 72.7], [172.7, 84.1],
        [172.7, 76.8], [177.8, 63.6], [177.8, 80.9], [182.9, 80.9], [170.2, 85.5],
        [167.6, 68.6], [175.3, 67.7], [165.1, 66.4], [185.4, 102.3], [181.6, 70.5],
        [172.7, 95.9], [190.5, 84.1], [179.1, 87.3], [175.3, 71.8], [170.2, 65.9],
        [193.0, 95.9], [171.4, 91.4], [177.8, 81.8], [177.8, 96.8], [167.6, 69.1],
        [167.6, 82.7], [180.3, 75.5], [182.9, 79.5], [176.5, 73.6], [186.7, 91.8],
        [188.0, 84.1], [188.0, 85.9], [177.8, 81.8], [174.0, 82.5], [177.8, 80.5],
        [171.4, 70.0], [185.4, 81.8], [185.4, 84.1], [188.0, 90.5], [188.0, 91.4],
        [182.9, 89.1], [176.5, 85.0], [175.3, 69.1], [175.3, 73.6], [188.0, 80.5],
        [188.0, 82.7], [175.3, 86.4], [170.5, 67.7], [179.1, 92.7], [177.8, 93.6],
        [175.3, 70.9], [182.9, 75.0], [170.8, 93.2], [188.0, 93.2], [180.3, 77.7],
        [177.8, 61.4], [185.4, 94.1], [168.9, 75.0], [185.4, 83.6], [180.3, 85.5],
        [174.0, 73.9], [167.6, 66.8], [182.9, 87.3], [160.0, 72.3], [180.3, 88.6],
        [167.6, 75.5], [186.7, 101.4], [175.3, 91.1], [175.3, 67.3], [175.9, 77.7],
        [175.3, 81.8], [179.1, 75.5], [181.6, 84.5], [177.8, 76.6], [182.9, 85.0],
        [177.8, 102.5], [184.2, 77.3], [179.1, 71.8], [176.5, 87.9], [188.0, 94.3],
        [174.0, 70.9], [167.6, 64.5], [170.2, 77.3], [167.6, 72.3], [188.0, 87.3],
        [174.0, 80.0], [176.5, 82.3], [180.3, 73.6], [167.6, 74.1], [188.0, 85.9],
        [180.3, 73.2], [167.6, 76.3], [183.0, 65.9], [183.0, 90.9], [179.1, 89.1],
        [170.2, 62.3], [177.8, 82.7], [179.1, 79.1], [190.5, 98.2], [177.8, 84.1],
        [180.3, 83.2], [180.3, 83.2]]
      }]
    }
    return json;
  }


  generateMultiLineXAxis() {
    let returnData: any;
    let seriesData: any = [];
    this.marketData.userProfileDataChoices.values.forEach((choices: any, index) => {
      if (choices) {
        seriesData.push(`${choices.label}`)
      }
    });
    returnData = seriesData ? seriesData : null
    return returnData;
  }

  generateMatrixMultiLineXAxis() {
    let returnData: any;
    let seriesData: any = [];
    returnData = this.marketData.marketData.map(x => x.questionText);
    return returnData;
  }

  generateMultiLineDataSeries() {
    let returnData: any = {}
    let mapedData: Array<any> = [];
    this.marketData.choices.forEach((choices: any) => {
      let seriesData: any = {};
      seriesData.name = choices.text
      seriesData.id = choices.id
      seriesData.data = []
      mapedData.push(seriesData);
    });

    this.marketData.userProfileDataChoices.values.forEach((choices: any) => {
      if (choices) {
        this.marketData.marketData.forEach((marketDataChoices: any, index: any) => {
          if (choices.id == marketDataChoices.choice) {
            this.marketData.choices.forEach((choices: any) => {
              mapedData.forEach((mapedDat: any) => {
                let findMaped: any = {};
                findMaped = _.find(this.marketData.marketData[index].grouping, ['key', mapedDat.id])
                if ((findMaped) && (mapedDat.id == choices.id)) {
                  mapedDat.data.push(findMaped.doc_count)
                } else if ((mapedDat.id == choices.id)) {
                  mapedDat.data.push(0)
                }
              });
            });
          }
        })
      }
    })

    returnData = mapedData ? mapedData : null
    return returnData;
  }

  generateMatrixMultiLineDataSeries(mop) {
    let dataList = [];
    if (this.basicColumnData && this.basicColumnData.length > 0) {
      for (let dataItem = 0; dataItem < this.basicColumnData.length; dataItem++) {
        this.basicColumnData[dataItem].choices.forEach(element => {
          const isChoiceExists = dataList.findIndex(x => x.name === element.text) > -1 ? true : false;
          if (isChoiceExists == false) {
            dataList.push({ name: element.text, data: [], order: element.order });
          }
          for (let choiceItem = 0; choiceItem < dataList.length; choiceItem++) {
            if (dataList[choiceItem].name === element.text) {
              if (mop === 'Percentage' && element.doc_percentage) {
                dataList[choiceItem].data.push(element.doc_percentage);
              } else {
                dataList[choiceItem].data.push(element.doc_count);
              }
            }
          }
        });
      }
    }
    _.forEach(dataList, element => {
      let arr = element.data;
      this.maxArray.push(Math.max.apply(null, arr));


    });
    this.maxPercentage = Math.max.apply(null, this.maxArray);
    this.maxPercentage = (this.maxPercentage <= 100) ? 100 : this.maxPercentage;
    dataList = _.sortBy(dataList, ['order']);
    return dataList;
  }

  generateDualAxis() {
    let json: any = {
      chart: {
        zoomType: 'xy',
        marginBottom: 50
      },
      title: {
        text: 'Average Monthly Temperature and Rainfall in Tokyo'
      },
      subtitle: {
        text: 'Source: WorldClimate.com'
      },
      xAxis: [{
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        crosshair: true
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          format: '{value}°C'
        },
        title: {
          text: 'Temperature'
        }
      }, { // Secondary yAxis
        title: {
          text: 'Rainfall'
        },
        labels: {
          format: '{value} mm'
        },
        opposite: true
      }],
      tooltip: {
        shared: true
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        y: 15,
        floating: true,
        backgroundColor: '#FFFFFF'
      },
      series: [{
        name: 'Rainfall',
        type: 'column',
        yAxis: 1,
        data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
        tooltip: {
          valueSuffix: ' mm'
        }

      }, {
        name: 'Temperature',
        type: 'spline',
        data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
        tooltip: {
          valueSuffix: '°C'
        }
      }],
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 475, 355, 105, 25)
                  .add();
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br/>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -20,
                      y: -20
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json;
  }
  //sort data

  sortData(sortOrder, sortBy, filteredData) {
    if (sortOrder === 'ASC') {
      sortOrder = 'DESC';
      const sortArray = filteredData.sort((a, b) => {
        if (a[sortBy] < b[sortBy]) {
          return -1;
        } else if (a[sortBy] > b[sortBy]) {
          return 1;
        } else {
          return 0;
        }
      });
      return sortArray;
    } else {
      sortOrder = 'ASC';
      const sortArray = filteredData.sort((a, b) => {
        if (a[sortBy] > b[sortBy]) {
          return -1;
        } else if (a[sortBy] < b[sortBy]) {
          return 1;
        } else {
          return 0;
        }
      });
      return sortArray;
    }
  }
  isEmptyObject(obj) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return true;
  }

  setBg(i) {
        const randomColor = [ '#c3d69b', '#fac08f ','#d99694', '#c0504d', '#090909', '#0D2472', '#6A2861'];
        return randomColor[i];
  }

  // generate  base column graph
  generateBaseColumnChart() {
    var self = this;
    let positionIncrement = 0;
    let finalPositionIncrement = 0;
    let localMarketData = this.marketData;
    const responseNumber = this.marketData.numberOfResponse;
    var color = [];
   // set color 
     if(this.basicColumnData.length > 0 && this.basicColumnData[0].choices != null) {
       color = this.basicColumnData[0].choices.map((obj, i) => {
         return (obj.color != null && obj.color.trim() != '') ? obj.color: self.setBg(i);
       });
     }

    var json = {
    colors: color,
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal'
            }
          }
        }]
      },
      chart: {
        renderTo: 'container',
        type: 'column'
      },
      legend: {
        align: 'center',
        itemMarginBottom: 8,
        verticalAlign: 'bottom',
        layout: 'horizontal'
      },
      title: {
        text: this.marketData.title
      },
      series: this.generateBasicCoulunData(this.marketData.methodOfOperation),
      yAxis: {
        max: this.calculateMaxDistance(localMarketData),
        title: {
          text: this.marketData.labels.yAxis
        }
      },
      xAxis: {
        categories: this.basicColumnData.map(x => x.questionText),
        title: {
          text: this.marketData.labels.xAxis
        },
        crosshair: true
      },

      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
            menuItems: null,
            onclick: function () {
              this.exportChart();
            }
          }
        },
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: '7px',
                  fontFamily: 'Montserrat',
                  fontWeight: "normal"
                },
                format: '{point.y:.1f}%'
              }
            }
          },
          subtitle: {
            text: 'N=' + responseNumber,
            align: 'left',
            x: 20,
            y: 11,
            style: {
              "font-size": "14px",
              "font-family": "'Montserrat', sans-serif",
              "color": "#fb625c",
              "font-weight": "600"
            }
          },
          series: [{
            dataLabels: {
              style: {
                fontSize: '10px',
                fontFamily: 'Montserrat',
                fontWeight: "normal"
              },
              format: '{point.y:.1f}%'
            }
          }],
          legend: {
            y: this.DistanceCalculation() + 75,
            itemDistance: 50,
            itemStyle: {
              fontSize: '7px',
              fontFamily: 'Montserrat',
            },
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          title: {
            x: 10,
            y : 30,
            style: {
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333333'
            }
          },
          xAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          yAxis: {
            title: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            },
            labels: {
              style: {
                fontFamily: 'Montserrat',
                fontSize: '10px',
                fontWeight: '400',
                color: '#666666'
              }
            }
          },
          chart: {
            events: {
              load: function () {
                var date = new Date();
                this.renderer.image('https://s3-ap-southeast-1.amazonaws.com/ecosystm-uploads-prod/ecosystem-logo-export.png', 490, 355, 100, 25)
                  .add();
                  if (localMarketData.appliedFilterList != undefined) {
                    this.renderer.text('Applied Master Filters ', 30, 300, 100, 25)
                      .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                    _.forEach(localMarketData.appliedFilterList, (obj) => {
                          this.renderer.text(obj.title + '  :  '  + obj.dataName, 30, 315 + positionIncrement, 100, 25)
                            .css({
                              fontSize: '7px',
                              fontFamily: 'Montserrat'
                            }).add();
                          positionIncrement = positionIncrement + 13;

                    });
                    finalPositionIncrement = 315 + positionIncrement;
                  }
                  if (localMarketData.appliedFilterList != undefined) {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, finalPositionIncrement + 15, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, finalPositionIncrement + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, finalPositionIncrement+ positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, finalPositionIncrement+positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
               }
                 else {
                if (localMarketData.userFilteredDataCN != undefined) {
                  this.renderer.text('Applied Filters ', 30, 300, 100, 25)
                    .css({ fontSize: '10px', fontFamily: 'Montserrat' }).add()
                  _.mapKeys(localMarketData, (value, key) => {
                    switch (key) {
                      case 'customFilteredChoiceNameValueAdoption':
                        this.renderer.text('Adoption: ' + localMarketData.customFilteredChoiceNameValueAdoption, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataSubDomainNameValue':

                        this.renderer.text('Solution Selection :' + localMarketData.userFilteredDataSubDomainNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataCountryNameValue':

                        this.renderer.text('Country :' + localMarketData.userFilteredDataCountryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataEmployeeValue':
                        this.renderer.text('Employee Size : ' + localMarketData.userFilteredDataEmployeeValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatageographyNameValue':
                        this.renderer.text('Region : ' + localMarketData.userFilteredDatageographyNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataindustryNameValue':
                        this.renderer.text('Industry : ' + localMarketData.userFilteredDataindustryNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDataitBudgetNameValue':
                        this.renderer.text('Budget : ' + localMarketData.userFilteredDataitBudgetNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatajobTitleNameValue':
                        this.renderer.text('Job Title : ' + localMarketData.userFilteredDatajobTitleNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'userFilteredDatalineOfBusinessNameValue':
                        this.renderer.text('Line of Business: ' + localMarketData.userFilteredDatalineOfBusinessNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      case 'customFilteredChoiceNameValue':
                        this.renderer.text('Maturity: ' + localMarketData.customFilteredChoiceNameValue, 30, 315 + positionIncrement, 100, 25)
                          .css({
                            fontSize: '7px',
                            fontFamily: 'Montserrat'
                          }).add();
                        positionIncrement = positionIncrement + 13;
                        break;
                      default: break;
                    }
                  });
                }
              }
                this.update({
                  credits: {
                    text: moment().month() + 1 + '/' + date.getFullYear() + `<br>www.ecosystm360.com`,
                    position: {
                      align: 'right',
                      verticalAlign: 'bottom',
                      x: -10,
                      y: -20
                    },
                    style: {
                      fontFamily: 'Montserrat',
                      fontSize: '8px',
                      fontWeight: '400',
                      color: '#666666'
                    }
                  },
                });
              }
            }
          }
        }
      }
    }
    return json
  }

  generateBasicCoulunData(mop) {
    let dataList = [];
    let uniqueChoiceArray = [];
    if (this.basicColumnData && this.basicColumnData.length > 0) {
      _.forEach(this.basicColumnData, (questionObj) => {
        _.forEach(questionObj.choices, (choiceObj) => {
          uniqueChoiceArray.push(choiceObj.text);
        });
      });
      uniqueChoiceArray = _.uniqWith(uniqueChoiceArray, _.isEqual);
      for (let dataItem = 0; dataItem < this.basicColumnData.length; dataItem++) {
        if (this.basicColumnData[dataItem].choices.length == uniqueChoiceArray.length) {
          this.basicColumnData[dataItem].choices.forEach(element => {
            const isChoiceExists = dataList.findIndex(x => x.name === element.text) > -1 ? true : false;
            if (isChoiceExists == false) {
              dataList.push({ name: element.text, data: [], order: element.order });
            }
            for (let choiceItem = 0; choiceItem < dataList.length; choiceItem++) {
              if (dataList[choiceItem].name === element.text) {
                if (mop === 'Percentage' && element.doc_percentage) {
                  dataList[choiceItem].data.push(element.doc_percentage);
                }else if(mop ==='Weight' && element.doc_count_weight){
                  dataList[choiceItem].data.push(element.doc_count_weight);
                } else {
                  dataList[choiceItem].data.push(element.doc_count);
                }
              }
            }
          });
        }
        else {
          let choiceExistFlagArray = [];
          uniqueChoiceArray.forEach((uniqChoiceText) => {
            choiceExistFlagArray.push(false);
            let chindex;
            this.basicColumnData[dataItem].choices.forEach((choiceObject) => {
              if (uniqChoiceText === choiceObject.text) {
                chindex = uniqueChoiceArray.findIndex(x => x === uniqChoiceText);
                choiceExistFlagArray[chindex] = true;
                const isChoiceExists = dataList.findIndex(x => x.name === choiceObject.text) > -1 ? true : false;
                if (isChoiceExists == false) {
                  dataList.push({ name: choiceObject.text, data: [], order: choiceObject.order });
                }
                for (let choiceItem = 0; choiceItem < dataList.length; choiceItem++) {
                  if (dataList[choiceItem].name === choiceObject.text) {
                    if (mop === 'Percentage' && choiceObject.doc_percentage) {
                      // dataList[choiceItem].data.push(choiceObject.doc_percentage);
                      dataList[choiceItem].data.splice(dataItem, 0, choiceObject.doc_percentage);
                    } else {
                      // dataList[choiceItem].data.push(choiceObject.doc_count);
                      dataList[choiceItem].data.splice(dataItem, 0, choiceObject.doc_count);
                    }
                  }
                }
              }
            });
            chindex = uniqueChoiceArray.findIndex(x => x === uniqChoiceText);
            if (choiceExistFlagArray[chindex] == false) {
              const isChoiceExists = dataList.findIndex(x => x.name === uniqChoiceText) > -1 ? true : false;
              if (isChoiceExists == false) {
                dataList.push({ name: uniqChoiceText, data: [] });
              }
              for (let choiceItem = 0; choiceItem < dataList.length; choiceItem++) {
                if (dataList[choiceItem].name === uniqChoiceText) {
                  if (mop === 'Percentage') {
                    // dataList[choiceItem].data.push(choiceObject.doc_percentage);
                    dataList[choiceItem].data.splice(dataItem, 0, 0);
                  } else {
                    // dataList[choiceItem].data.push(choiceObject.doc_count);
                    dataList[choiceItem].data.splice(dataItem, 0, 0);
                  }
                }
              }
            }
          });
        }
      }
    }
    _.forEach(dataList, element => {
      let arr = element.data;
      this.maxArray.push(Math.max.apply(null, arr));


    });
    this.maxPercentage = Math.max.apply(null, this.maxArray);
    this.maxPercentage = (this.maxPercentage <= 100) ? 100 : this.maxPercentage;
    dataList = _.sortBy(dataList, ['order']);
    return dataList;
  }

  toMatStackData(operation): Array<object> {
    let dataList = [];
    let choiceList = [];
    _.forEach(this.basicColumnData, (dataObj) => {
      _.forEach(dataObj.choices, (choiceObj) => {
        choiceList.push({
          text: choiceObj.text,
          order: choiceObj.order,
          color: choiceObj.color ? choiceObj.color : ''

        });
      })
    })
    choiceList = _.uniqBy(choiceList, 'text');
    if (this.basicColumnData && this.basicColumnData.length > 0) {
      for (let dataItem = 0; dataItem < this.basicColumnData.length; dataItem++) {
        choiceList.forEach(element => {
          let currentChoiceElement = _.find(this.basicColumnData[dataItem].choices, { 'text': element.text });
          const isChoiceExists = dataList.findIndex(x => x.name === element.text) > -1 ? true : false;
          if (isChoiceExists == false) {
            dataList.push({ name: element.text, data: [], color: element.color ? element.color : '', order:element.order });
          }
          const dataChoiceIndex = dataList.findIndex(x => x.name === element.text);
          if (currentChoiceElement === undefined) {
            dataList[dataChoiceIndex].data.push(0);
          } else if (operation === 'Percentage' && currentChoiceElement.doc_percentage) {
            dataList[dataChoiceIndex].data.push(currentChoiceElement.doc_percentage);
            let obj: any = {};
            obj.name = currentChoiceElement.text;
            // obj.data = this.getArray(data, x.id, operation);
            dataList.push(obj);
          } else {
            dataList[dataChoiceIndex].data.push(currentChoiceElement.doc_percentage);
          }
        });
      }
    }
    // matrix stacked bar legends repeating issue fixes. objects with name only and without data removing to fix the legends repeating issue
    dataList = _.filter(dataList, (obj) => {
      return obj.data && obj.data.length;
    });
    dataList= _.sortBy(dataList,['order']);

    return dataList;
  }
  getBarGraphToolTip(marketData) {
    if (this.marketData.methodOfOperation === 'Mean' && this.marketData.content['X'].isMatrix === true && this.marketData.graphType.graphType === 'bar') {
      return `{series.name}: <b>{point.y:.1f}</b>`
    }
    else {
      if (marketData && marketData.methodOfOperation === 'Mean') {
        return `{series.name}: <b>{point.y:.1f}</b>`
      }
      else if (marketData && marketData.methodOfOperation === 'Frequency') {
        return `{series.name}: <b>{point.y:.1f}</b>`
      }
      else {
        return `{series.name}: <b>{point.y:.1f}%</b>`
      }
    }
  }
  calculateMaxDistance(localMarketData) {
    let x;
    let largerstDocPercentage = 0;
    if (localMarketData.methodOfOperation === "Percentage") {
      localMarketData.marketData.forEach(choices => {
        choices.choices.forEach(choice => {
          if (largerstDocPercentage < choice.doc_percentage) {
            largerstDocPercentage = choice.doc_percentage;
          }
        });
      });
      x = largerstDocPercentage + (10 - (largerstDocPercentage % 10));
      return x;
    }
    else
      return null;
  }
  setTreeMapColor(choices, marketObj, colorIndex) {
    if (choices.length > 0) {
      let selectedChoiceObj = _.find(choices, { 'text': marketObj.text })
      if (selectedChoiceObj.color) {
        return selectedChoiceObj.color;
      }
      else {
        return this.bubleColorService.getRandomColor(colorIndex);
      }
    }
    else {
      return this.bubleColorService.getRandomColor(colorIndex);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/market-data-chart-generator.service.ts